import { z } from 'zod';

export const agreementTypeSchema = z.enum([
  'general_contract_and_quotation',
  'general_quotation',
  'project_specific_quotation',
]);
export type AgreementType = z.infer<typeof agreementTypeSchema>;
